<div class="payment-submit-button-container">
  @if (submissionErrorMessages.length > 0) {
    <app-error-notification title="Error:" classes="has-text-black mb-4" data-qa-id="submission errors">
      @for (errorMessage of submissionErrorMessages; track errorMessage) {
        <p [innerHTML]="errorMessage"></p>
      }
    </app-error-notification>
  }

  @if (validationError) {
    <app-error-notification
      id="reviewFormAlert"
      title="Incomplete:"
      classes="has-text-centered mb-4"
      data-qa-id="validation errors"
    >
      {{ validationError.message }}
    </app-error-notification>
  }

  @if (!processing && externalPayment && !validationError) {
    <div class="external-payment">
      <ngx-payment-external-pay-button
        [payment]="externalPayment"
        (paymentSubmit)="onSubmit()"
        (paymentFailed)="onPaymentError($event)"
      ></ngx-payment-external-pay-button>
    </div>
  }

  @if (!processing && !externalPayment) {
    <div class="submit-button-wrapper">
      @if (displayTrustBadge) {
        <div
          class="trustedsite-trustmark trustedsite-secure-checkout-badge"
          data-type="212"
          data-width="120"
          data-height="50"
        ></div>
      }
      <button
        type="button"
        [class]="`button is-large is-fullwidth has-text-white action button-place-your-order ${submitButtonClass}`"
        (click)="onSubmit()"
        data-qa-id="Submit"
      >
        <span>{{ buttonText }}</span>
        <span class="icon">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  }

  @if (processing) {
    <div class="p-4 processing-container" data-qa-id="Processing Your Order Loader">
      <i class="loading-spinner"></i>
      <span>Processing your order...</span>
    </div>
  }
</div>
